import { Component, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { faInstagram, faFacebookF, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { FooterLegalPolicies } from './footer-legal-policies/footer-legal-policies';
import { PoweredByVanaComponent } from '../powered-by-vana/powered-by-vana';

@Component({
  selector: 'app-footer-component',
  imports: [MatIconModule, MatButtonModule, FaIconComponent, FooterLegalPolicies, RouterLink, PoweredByVanaComponent],
  templateUrl: './footer-component.html',
  styleUrl: './footer-component.scss',
})
export class FooterComponent {
  faInstagram = faInstagram;
  faFacebookF = faFacebookF;
  faWhatsapp = faWhatsapp;
  readonly currentYear = new Date().getFullYear();
  /** Defer Google Maps embed until requested — avoids blocked/aborted iframe requests on every page. */
  mapExpanded = signal(false);

  showMap(): void {
    this.mapExpanded.set(true);
  }
}
